import React from 'react';

import { ReactComponent as HeadsetIcon } from '../../assets/sideMenu/headset.svg';

import styles from './SupportButton.module.css';

const SupportButton = ({ label, onClick = () => { } }) => (
  <button className={styles.supportButton} onClick={onClick} type="button">
    <HeadsetIcon className={styles.headsetIcon} />

    {label}
  </button>
);

export { SupportButton };
